module.exports = __webpack_public_path__ + "img/Small-Vertical-Rectangular-Attachment-12.d6c1b1fb.png";